module.exports = __webpack_public_path__ + "static/img/2_7_1.d79e98f4.jpg";